let formLoaded = true;
let mktoFormElm = document.querySelector('form.mktoForm');

window.isFormLoaded = false;

function reformatCheckbox(checkboxElm) {
  const row = checkboxElm.closest('.mktoFormRow');
  const checkboxId = checkboxElm.getAttribute('id');
  const label = row.querySelector('label[for=' + checkboxId + ']');

  if (null !== label) {
    const checkbox = checkboxElm.cloneNode(true);

    checkboxElm.remove();

    label.insertAdjacentHTML('afterbegin', '<span class="checkmark"></span>');
    label.prepend(checkbox);

    if (!label.classList.value.includes('label-container')) {
      label.classList.add('label-container');
    }
  }
}

function reformatRadio(radioElm) {
  const row = radioElm.closest('.mktoFormRow');
  const radioId = radioElm.getAttribute('id');
  const label = row.querySelector('label[for=' + radioId + ']');

  if (null !== label) {
    const radio = radioElm.cloneNode(true);

    radioElm.remove();

    label.insertAdjacentHTML('afterbegin', '<span class="radiomark"></span>');
    label.prepend(radio);

    if (!label.classList.value.includes('label-container')) {
      label.classList.add('label-container');
    }
  }
}

function checkLabel(labelElm) {
  if (0 === labelElm.innerText.length && 0 === labelElm.children.length) {
    labelElm.remove();
  }
}

function validateInput(inputElm, value, row) {
  if (value.length > 0 && !row.classList.value.includes('complete')) {
    row.classList.add('complete');
    row.classList.remove('error');
  } else if (0 === value.length) {
    row.classList.remove('complete');

    if (inputElm.classList.value.includes('mktoRequired')) {
      row.classList.add('error');

      const fieldWrap = inputElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please fill out this field.</div>');
      }
    }
  }
}

function validateSelect(selectElm, value, row) {
  if (value.length > 0 && !row.classList.value.includes('complete')) {
    row.classList.add('complete');
    row.classList.remove('error');
  } else if (0 === value.length) {
    row.classList.remove('complete');

    if (selectElm.classList.value.includes('mktoRequired')) {
      row.classList.add('error');

      const fieldWrap = selectElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please select an option.</div>');
      }
    }
  }
}

function validateTextarea(textareaElm, value, row) {
  if (value.length > 0 && !row.classList.value.includes('complete')) {
    row.classList.add('complete');
    row.classList.remove('error');
  } else if (0 === value.length) {
    row.classList.remove('complete');

    if (textareaElm.classList.value.includes('mktoRequired')) {
      row.classList.add('error');

      const fieldWrap = textareaElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please fill out this field.</div>');
      }
    }
  }
}

function handleSubmit() {
  setTimeout(() => {
    checkForInvalidFields();
  }, 500);
}

function checkForInvalidFields() {
  const allInputElms = mktoFormElm.querySelectorAll('input');
  allInputElms.forEach((inputElm) => {
    const row = inputElm.closest('.mktoFormRow');

    if (inputElm.classList.value.includes('mktoInvalid')) {
      row.classList.remove('complete');
      row.classList.add('error');

      const fieldWrap = inputElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please fill out this field.</div>');
      }
    }
  });
  const allTextareaElms = mktoFormElm.querySelectorAll('textarea');
  allTextareaElms.forEach((textareaElm) => {
    const row = textareaElm.closest('.mktoFormRow');

    if (textareaElm.classList.value.includes('mktoInvalid')) {
      row.classList.remove('complete');
      row.classList.add('error');

      const fieldWrap = textareaElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please fill out this field.</div>');
      }
    }
  });
  const allSelectElms = mktoFormElm.querySelectorAll('select');
  allSelectElms.forEach((selectElm) => {
    const row = selectElm.closest('.mktoFormRow');

    if (selectElm.classList.value.includes('mktoInvalid')) {
      row.classList.remove('complete');
      row.classList.add('error');

      const fieldWrap = selectElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please select an option.</div>');
      }
    }
  });
  const allCheckboxListElms = mktoFormElm.querySelectorAll('div.mktoCheckboxList');
  allCheckboxListElms.forEach((selectElm) => {
    const row = selectElm.closest('.mktoFormRow');

    if (selectElm.classList.value.includes('mktoInvalid')) {
      row.classList.remove('complete');
      row.classList.add('error');

      const fieldWrap = selectElm.closest('.mktoRequiredField');
      if (null === fieldWrap.querySelector('.mktoCustomErrorMsg')) {
        fieldWrap.insertAdjacentHTML('beforeend', '<div class="mktoCustomErrorMsg">Please select an option.</div>');
      }
    }
  });
}

function handleForm() {
  const handleCheckboxElms = mktoFormElm.querySelectorAll('input[type="checkbox"]');
  handleCheckboxElms.forEach((checkboxElm) => {
    reformatCheckbox(checkboxElm);
  });

  const handleRadioElms = mktoFormElm.querySelectorAll('input[type="radio"]');
  handleRadioElms.forEach((radioElm) => {
    reformatRadio(radioElm);
  });

  const handleLabelElms = mktoFormElm.querySelectorAll('label');
  handleLabelElms.forEach((labelElm) => {
    checkLabel(labelElm);
  });

  const handleAllInputElms = mktoFormElm.querySelectorAll('input');
  handleAllInputElms.forEach((inputElm) => {
    const row = inputElm.closest('.mktoFormRow');

    inputElm.addEventListener('keyup', function (e) {
      validateInput(inputElm, e.target.value, row);
    });
  });

  const handleAllSelectElms = mktoFormElm.querySelectorAll('select');
  handleAllSelectElms.forEach((selectElm) => {
    const row = selectElm.closest('.mktoFormRow');

    selectElm.addEventListener('change', function (e) {
      validateSelect(selectElm, e.target.value, row);
    });
  });

  const handleAllTextareaElms = mktoFormElm.querySelectorAll('textarea');
  handleAllTextareaElms.forEach((textareaElm) => {
    const row = textareaElm.closest('.mktoFormRow');
    textareaElm.addEventListener('keyup', function (e) {
      validateTextarea(textareaElm, e.target.value, row);
    });
  });

  const submitBtn = mktoFormElm.querySelector('button[type="submit"]');
  if (null !== submitBtn) {
    submitBtn.addEventListener('click', () => {
      handleSubmit();
    });
  }
}

function hasFormLoaded() {
  mktoFormElm = document.querySelector('form.mktoForm');

  if (null !== mktoFormElm && mktoFormElm.classList.length > 1 && 0 < mktoFormElm.children.length && !formLoaded) {
    window.isFormLoaded = true;
    formLoaded = true;

    handleForm();
  } else if (null === mktoFormElm || 0 === mktoFormElm.classList.length || 0 === mktoFormElm.children.length) {
    formLoaded = false;
  }

  // Keep checking for new forms
  setTimeout(function () {
    hasFormLoaded();
  }, 1000);
}

hasFormLoaded();
